import{jsx as x}from"react/jsx-runtime";import b,{css as o}from"styled-components";import{mq as j}from"../../shared/media-queries.js";const k="row",v="1rem",m="center",u=(r,e)=>(e==="gap"||e==="row-gap")&&typeof r=="number"?`${r}rem`:r,C=({$direction:r,$justify:e,$align:a,$gap:t,$rowGap:s,$wrap:$,$basis:p,$grow:l,$shrink:f,$inlineChildren:g})=>o`
  display: flex;

  ${r&&["column","column-reverse"].includes(String(r))&&!g&&o`
    & > * {
      width: 100%;
    }
  `}

  ${[[r,"flex-direction"],[e,"justify-content"],[a,"align-items"],[t,"gap"],[s,"row-gap"],[s,"row-gap"],[$,"flex-wrap"],[p,"flex-basis"],[l,"flex-grow"],[f,"flex-shrink"]].map(([i,n])=>{if(typeof i=="string"||typeof i=="number")return o`
        ${n}: ${u(i,n)};
      `;if(typeof i=="object"){const w=[],{initial:c,...d}=i;return c&&w.push(o`
          ${n}: ${u(c,n)};
        `),Object.entries(d).forEach(([h,y])=>{w.push(o`
          ${j(h)} {
            ${n}: ${u(y,n)};
          }
        `)}),w}else return""})}
`,G=b.div(C),q=({direction:r,justify:e,align:a,gap:t,rowGap:s,wrap:$,basis:p,grow:l,shrink:f,inlineChildren:g=!1,...i})=>x(G,{$direction:r??k,$justify:e??m,$align:a??m,$gap:t??v,$rowGap:s,$wrap:$,$basis:p,$grow:l,$shrink:f,$inlineChildren:g,...i});export{q as default};
